import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import PincodeServices from '../../services/LocationServices';
function PincodeUpdate({ data, closeModal, onSuccess }) {
  const [formValues, setFormValues] = useState({
    area: '',
    code: '',
  });

  useEffect(() => {
    if (data) {
      setFormValues({
        area: data?.area || '',
        code: data?.code || '',
      });
    }
  }, [data]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await PincodeServices.updatePincode(data.id, {
        area: formValues.area,
        code: formValues.code
      });
      alert('Pincode updated successfully');
      onSuccess();
      closeModal();
    } catch (error) {
      console.error('Failed to update pincode', error);
      alert('Failed to update pincode');
    }
  };

  return (
    <>
      <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Pincode</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
            </div>
            <div className="modal-body">
              <div className="container-box px-5">
                <div className="container-box-inner table-reponsive-tabe">
                  <div className="page-details">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-lg-6 col-sm-12">
                          <div className="input-field">
                            <label>Area Name<span className="red">*</span></label>
                            <input
                              type="text"
                              name="area"
                              className="form-control"
                              value={formValues.area}
                              onChange={handleInputChange}
                              placeholder="Enter area name"
                            />
                          </div>
                        </div>

                        <div className="col-lg-6 col-sm-12">
                          <div className="input-field">
                            <label>Pincode<span className="red">*</span></label>
                            <input
                              type="text"
                              name="code" 
                              className="form-control"
                              value={formValues.code}
                              onChange={handleInputChange}
                              placeholder="Enter pincode"
                              pattern="[0-9]{6}"
                              title="Pincode must be 6 digits"
                            />
                          </div>
                        </div>
                      </div>
                      <button className="submit-green-btn">Update</button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>




    </>
  );
}

export default PincodeUpdate;